import React from "react";
import { useNavigate } from "react-router-dom";

const agents = [
  {
    name: "Symptoms & Risk Analyzer",
    description: "Analyze your symptoms and receive AI-driven risk insights.",
    path: "/diabetes-agent/symptoms",
    active: true,
  },
  {
    name: "Diet & Nutrition Advisor",
    description: "Get personalized diet suggestions based on AI analysis.",
    path: "#",
    active: false,
  },
  {
    name: "Exercise & Activity Coach",
    description: "AI-guided exercise plans to maintain healthy glucose levels.",
    path: "#",
    active: false,
  },
  {
    name: "Trend & Report Generator",
    description: "Visualize your glucose trends and get reports easily.",
    path: "#",
    active: false,
  },
];

const DiabetesAIAgentMenu: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = (agent: typeof agents[0]) => {
    if (agent.active) navigate(agent.path);
  };

  return (
    <div className="container py-5">
      <h1 className="text-center text-primary mb-4">Diabetes AI Agents</h1>
      <p className="text-center text-muted mb-5">
        Explore AI tools for diabetes management. Features marked as{" "}
        <span className="badge bg-warning text-dark">Coming Soon</span> will be added soon!
      </p>

      <div className="row g-4">
        {agents.map((agent, idx) => (
          <div key={idx} className="col-sm-12 col-md-6 col-lg-4">
            <div
              className={`card h-100 shadow-sm ${
                agent.active ? "border-primary" : "border-secondary"
              }`}
              style={{ cursor: agent.active ? "pointer" : "not-allowed" }}
              onClick={() => handleClick(agent)}
            >
              <div className="card-body d-flex flex-column">
                <h5
                  className={`card-title ${
                    agent.active ? "text-dark" : "text-secondary"
                  }`}
                >
                  {agent.name}
                </h5>
                <p className="card-text flex-grow-1">{agent.description}</p>

                <div>
                  {agent.active ? (
                    <span className="badge bg-success">Available</span>
                  ) : (
                    <span className="badge bg-warning text-dark">Coming Soon</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DiabetesAIAgentMenu;
